var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.priority)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipText,
    delay: { show: 500, hide: 0 },
    hideOnClick: true,
  }),expression:"{\n    content: tooltipText,\n    delay: { show: 500, hide: 0 },\n    hideOnClick: true,\n  }"}],staticClass:"priority-flag",class:_vm.priority},[_c('fluent-icon',{staticClass:"priority-flag__mark",attrs:{"size":_vm.size,"icon":"flag","type":"filled"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }